import './styles.css'

function PageTitle(props) {
  return (
    <h1 className='PageTitle'>{props.title}</h1>
  );
}

export default PageTitle;